module.exports = {
  API_URL: '//api.customers.qc.viralstyle.com',
  API_ROOT: '/api',
  APP_PROTOCOL: 'https',
  APP_URL: 'qc.viralstyle.com',
  APP_DOMAIN: 'viralstyle.com',
  ENVIRONMENT: 'Staging',
  CLIENT_ADMIN_API_URL: 'https://api.clients.qc.viralstyle.com/v3/',
  PRIMARY_COLOR: '#00B398',
  ERROR_COLOR: '#da625a',
  INFO_COLOR: '#5D9CD1',
  RAVEN_URL: 'https://094877dac2764d6c9c158ab7077ef73d@sentry.io/1356280',
  GOOGLE_RECAPTCHA_SITEKEY: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
  GOOGLE_PLACES_API_KEY: 'AIzaSyANmRdeyE6Y1fb7OF4XZ8SmACOjB4YI2ug',
  PAYPAL: { ENVIRONMENT: 'sandbox', MERCHANT_ID: 'dev-paypal-merch@viralstyle.com' },
  SMARTY_STREETS: { ENABLED: false, ID: '18226769276996505' },
  FB_ID: '581319138682569',
  FB_ACQN_ID: '581319138682569',
  GA_ID: 'UA-73140867-1',
  G_ADS_ID: 'AW-111111111',
  G_ADS_CONVERSION_LABEL: 'hahahahah_mEQvNehzQM',
  G_ADS_CONVERSION_LABEL_REGISTER: 'hahahahahahahah',
  KEEN_PROJECT_ID: '5af59f7ac9e77c0001822469',
  KEEN_WRITE_KEY: '83954ACFB0A7EFEAEE3CA84AB9E42B4530E34FF52575B7B231B8C575F117460569DAC2849BE2B57B6C6D7456E900DB786AA7C3F8B20A1853C6CF7291712027511C53215C9A9FD7FB62C734F5514620F9956B5296714D0C10A009DBE46924AB39',
  AFFILIATE_ID: 'VSAFFID',
  KLAVIYO_ID: null,
  HOLIDAY_MESSAGE: {
    endDay: 24,
    apparel: {
      message: '<small>If shipped to a US address your order will arrive before Dec. 24th, Happy Holidays!</small>',
      redBorder: false,
    },
    nonApparel: {
      message: '<small>If shipped to a US address your order will arrive before Dec. 24th, Happy Holidays!</small>',
      redBorder: false,
    },
    bothInCart: {
      message: '<small>If shipped to a US address your order will arrive before Dec. 24th, Happy Holidays!</small>',
      redBorder: false,
    },
  },
  SNAPCHAT: '854bfe68-c0a8-41bf-a592-879f730dd524',
  ADROLL_ADV_ID: 'EPT6FTQ2QVDERHDQL7MH4I',
  ADROLL_PIX_ID: 'GYMI24VVPREBBLMXI4IJUY',
  CDN: '/',
  TIKTOK: 'B2OHR623E7ASH10R3HO0',
};
